// extracted by mini-css-extract-plugin
export default {"PolicyPreviewButton__button":"PolicyPreviewButton__button_WvVxS"};